



























import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { FeedProduct, feedProductSubtypeOptions, feedProductSubtypeLabelMap } from '@/pages/account/products/feed/models';
import { ProductSubtype } from '@/api';
import { FeedProductService } from '@/pages/account/products/feed/services';
import InformationRow from '@/components/display/information-row.vue';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		InformationRow,
	},
})
export default class FeedProductSubtype extends Vue {
	@Prop({ required: true, type: Object })
	private feedProduct!: FeedProduct;

	@Inject('feedProductService')
	private service!: FeedProductService;

	public readonly subtypeOptions = feedProductSubtypeOptions;

	public editing: boolean = false;
	public selectedSubtype: ProductSubtype = ProductSubtype.Feed;

	private toast: Toast = new Toast();

	@Watch('feedProduct.subtype', { immediate: true })
	public onSubtypeChanged(val: ProductSubtype | null | undefined): void {
		if (!this.editing) {
			this.selectedSubtype = val ?? ProductSubtype.Feed;
		}
	}

	@Watch('editing')
	public onEditingChanged(editing: boolean): void {
		if (!editing) {
			this.selectedSubtype = this.feedProduct.subtype ?? ProductSubtype.Feed;
		}
	}

	public get selectedSubtypeLabel(): string {
		return feedProductSubtypeLabelMap[this.selectedSubtype];
	}

	public toggleEditing(): void {
		this.editing = !this.editing;
	}

	public cancelEditing(): void {
		this.editing = false;
	}

	public async updateSubtype(): Promise<void> {
		const previousSubtype = this.feedProduct.subtype;
		this.feedProduct.subtype = this.selectedSubtype;
		const result = await this.service.updateProduct(this.feedProduct);
		if (result?.errorMessage) {
			this.feedProduct.subtype = previousSubtype;
			this.toast.makeToast(result.errorMessage, 'Failed to update subtype', 'danger');
			return;
		}
		this.toast.makeToast('Subtype updated', 'Success', 'success');
		this.editing = false;
	}
}
